import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "restreaming-server-blocking",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "One protected event's restreaming-server (ISP) blocking outcomes, by country.",
    domain: "reports",
    visual: "Cards",
    purposes: ["reporting"],
    reportEdition: true,
    audiences: ["analyst", "client"],
  },
  layout: { skeleton: "list" },
  defaultLayoutClassName: "col-span-12 xl:col-span-6",
};
